export enum ApplicationState {
  INACTIVE = 'No Active Application',
  PAUSED = 'paused',
  RUNNING = 'running',
  COMPLETED = 'completed',
  INVALID = 'invalid'
}